import React from "react";
import Typist from "react-typist";
import AppConfig from "./AppConfig";
import "../../Css/Resume1.css";

function Youtube_Courses() {
  return (
    <div className="resume1_home_section">
      <Typist className="resume1_home_section_typing">
        <span className="resume1_home_section_h1">
          {" "}
          Hello! My name is Murtaza Hassani{" "}
        </span>
        <Typist.Backspace count={1} delay={200} />
        <br />
        <br />
        <span className="resume1_home_section_span">
          {" "}
          I am a full stack web developer!{" "}
        </span>
      </Typist>
      <Resume1_section_2 />
      <Resume1_section_3 />
      <Footer />
    </div>
  );
}

// Section one about who am i
function Resume1_section_2() {
  return (
    <div className="section_one_home">
      <img
        className="section_one_home_img"
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUx1Qn9jorSjVePRX2FxUmnGe_poqZEnGItA&usqp=CAU"
        alt=""
      />
      <h1 className="section_one_home_h1">Who am i?</h1>
      <p className="section_one_home_p">
        {" "}
        I’ve gone through a number of phases in my career, and each of them has
        informed my current work ethos and philosophy. I have excelled in a
        number of project management roles in diverse industries, and believe
        that my number one asset is my ability to adapt to any challenge that is
        thrown my way.
      </p>
    </div>
  );
}

// Section two about my skills

function Resume1_section_3() {
  return (
    <div>
      <h1 className="res_foods_h1_title">Get My courses </h1>

      <div className="row py-8">
        {AppConfig.youtubeVideos.map((video) => {
          return (
            <div className="col-md-4 p-3 card-hover" key={video.id}>
              <div class="card_courses">
                <a
                  href={`https://www.youtube.com/watch?v=${video.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    class="card-img-top_courses"
                    src={`https://img.youtube.com/vi/${video.id}/sddefault.jpg`}
                    alt="Card cap"
                  />
                  <div class="card-body_courses">
                    <h5 class="card-title_courses">{video.title}</h5>
                  </div>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Footer section
function Footer() {
  return (
    <div className="footer_section">
      <p>© Copyright Murtaza. All Rights Reserved </p>
    </div>
  );
}

export default Youtube_Courses;
